<template>
    <div class="card-body">
        <div class="table-responsive">
            <filter-input></filter-input>
            <vuetable ref="vuetable"
                :api-url="route('admin.clients.index')"
                data-path="clients"
                pagination-path=""
                :append-params="moreParams"
                :css="css.table"
                :fields="fields"
                :noDataTemplate="'Datos no disponibles'"
                :sort-order="sortOrder"
            >
                <div slot="index" slot-scope="props">
                    {{ props.rowIndex + 1 }}
                </div>
				<div slot="name" slot-scope="props">
					<img
                        class="logosclientesadmin cursor-pointer"
                        :title="props.rowData.name"
                        :src="props.rowData.logo_url"
                        v-show="props.rowData.logo_url"
                    >
                    <span v-show="! props.rowData.logo_url">{{ props.rowData.name }}</span>
				</div>
                <div slot="client-name" slot-scope="props">
                    <span :title="props.rowData.name">{{ str_limit(props.rowData.name, 20) }}</span>
                </div>
				<div slot="url_admin" slot-scope="props">
                    <a
                        target="_blank"
                        :href="props.rowData.url_admin"
                    >Administración</a>
                </div>
                <div slot="url_home" slot-scope="props">
                    <a
                        target="_blank"
                        :href="props.rowData.url_home"
                        v-if="props.rowData.url_home"
                    >Sitio principal</a>
                    <span v-else>-</span>
                </div>
                <div slot="git_branch" slot-scope="props" v-if="emails.includes(email)">
                    <span v-if="props.rowData.git_branch">{{ props.rowData.git_branch }}</span>
                    <span v-else>-</span>
                </div>
                <div slot="actions" slot-scope="props">
                    <a
                        class="btn btn-secondary btn-sm"
                        title="Copiar GIT Branch"
                        @click.prevent="handleCopy(route('api.clients.show', props.rowData.slug))"
                        :href="route('api.clients.show', props.rowData.slug)"
                        v-if="emails.includes(email)"
                    >Copiar GIT</a>
                    <a
                        class="btn btn-primary btn-sm"
                        :href="route('admin.clients.edit', props.rowData.slug)"
                    >Editar</a>
                    <a
                        class="btn btn-danger btn-sm"
                        @click.prevent="handleDelete(props.rowData)"
                        :href="route('admin.clients.destroy', props.rowData.slug)"
                    >Borrar</a>
                </div>
            </vuetable>
        </div>
    </div>
</template>

<script>
    import FilterInput from '@/components/FilterInput'
    import Vuetable from 'vuetable-2'
    import VueEvents from 'vue-events'
    Vue.use(VueEvents)

    export default {
        props: {
            emails: Array,
            email: String
        },
        data() {
            return {
                css: {
                    table: {
                        tableClass: 'table table-bordered table-sm text-center table-hover',
                        loadingClass: 'loading',
                        ascendingIcon: 'bi bi-chevron-up',
                        descendingIcon: 'bi bi-chevron-down',
                        handleIcon: 'bi bi-list',
                    }
                },
                sortOrder: [
                    {
                        field: 'name',
                        sortField: 'name',
                        direction: 'asc'
                    }
                ],
                fields: [
                    {
                        dataClass: 'text-nowrap numerocliente',
                        icon: 'zoom icon',
                        name: 'index',
                        title: '#',
                        titleClass: 'text-nowrap'
                    },
                    {
                        dataClass: 'text-nowrap',
                        icon: 'zoom icon',
                        name: 'name',
                        sortField: 'name',
                        title: 'Cliente',
                        titleClass: 'text-nowrap',
                        width: '35%'
                    },
                    {
                        dataClass: 'text-nowrap',
                        icon: 'zoom icon',
                        name: 'client-name',
                        sortField: 'client-name',
                        title: 'Nombre',
                        titleClass: 'text-nowrap',
                        width: '35%'
                    },
                    {
                        dataClass: 'text-nowrap administracioncliente',
                        icon: 'zoom icon',
                        name: 'url_admin',
                        sortField: 'url_admin',
                        title: 'Administración',
                        titleClass: 'text-nowrap',
                    },
                    {
                        dataClass: 'text-nowrap sitioprincipalcliente',
                        icon: 'zoom icon',
                        name: 'url_home',
                        sortField: 'url_home',
                        title: 'Sitio principal',
                        titleClass: 'text-nowrap'
                    },
                    {
                        dataClass: 'text-nowrap',
                        icon: 'zoom icon',
                        name: 'git_branch',
                        sortField: 'git_branch',
                        title: 'Git Branch',
                        titleClass: 'text-nowrap',
                        visible: this.emails.includes(this.email)
                    },
                    {
                        dataClass: 'text-nowrap',
                        name: 'actions',
                        title: 'Acción'
                    },
                ],
                moreParams: {}
            }
        },
        methods: {
            /**
             * Limitar carácteres de un string
            */
            str_limit (string, length = 50) {
                return String(string).length > length ? String(string).substring(0, length) + '...' : string
            },
            handleCopy(text) {
                navigator.clipboard.writeText(text)
            },
            handleDelete(client) {
                if (confirm('Eliminar cliente ' + client.name + '?')) {
                    axios.delete(this.route('admin.clients.destroy', client))
                    .then(response => {
                        this.$toast.open({
                            message: 'Cliente eliminado correctamente',
                            type: 'success',
                            duration: 5000,
                            dismissible: true,
                            position: 'top-right'
                        })
                        this.$refs.vuetable.refresh()
                    }).catch(error => {
                        console.log(error)
                    })
                }
            }
        },
        components: {
            Vuetable,
            'filter-input': FilterInput
        },
        events: {
            'filter-set' (filterText) {
                this.moreParams = {
                    search: filterText
                }
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },
            'filter-reset' () {
                this.moreParams = {}
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            }
        }
    }
</script>